import React from "react";

const DeleteModalSnapp = ({ showModal, closeModal, deleteItem, text }) => {
  return (
    <div
      className={`modal ${showModal ? "show" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ display: showModal ? "block" : "none" }}
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body p-3">
            <div className="d-flex justify-content-between align-content-center mx-1">
              <p> حذف {text} </p>
              <span className="fs-5">
                <i
                  className="bi bi-x-circle"
                  role="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></i>
              </span>
            </div>
            <div className="d-flex flex-column align-items-center mb-4">
              <span style={{ display: "block", textAlign: "center" }}>
                حذف در نرم‌افزار، آیتم را از اسنپ‌فود پاک نمی‌کند.
              </span>
              <span>قبل از حذف، با اسنپ هماهنگ و ریلیشن‌ها را بررسی کنید</span>
            </div>
            <div className="d-flex justify-content-around align-content-center">
              <button
                type="button"
                className="btn custome-btn btn-outline-purple w-50 ms-2"
                onClick={closeModal}
              >
                خیر
              </button>
              <button
                type="button"
                className="btn custome-btn btn-danger w-50 me-2"
                onClick={deleteItem}
              >
                بله
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModalSnapp;
